/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.conference.component.rpc.ui.service.v1.WebinarFormsAppStatusChirpUIService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import * as References from './WebinarFormsAppStatusChirpUIService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.conference.component.rpc.ui.service.v1.WebinarFormsAppStatusChirpUIService#appStatus
 */
export const APP_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'appStatus',
  args: [],
  fetcher(_, ctx) {
    return chirpClient.call(References.appStatusRpc, {
      timeout: ctx.timeout
    });
  }
});